import axios from 'axios';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import MovingChart from '../../components/chart/MovingChart';
import DefaultLoader from '../../components/loader/DefaultLoader';
import ballImage from '../../assets/img/icon/ball_icon.png';
import dateSetting from '../../utils/dateSetting';
import Form from 'react-bootstrap/Form';

function MovingChartMain({profile, leagueType = 4201}) {
    const [cookies] = useCookies(['hiball_token']);
    let [movingChartData, setMovingChartData] = useState([]);
    let [avgStat, setAvgStat] = useState({});
    let {playerId, type} = profile;
    let dateObj = dateSetting();
    let [season, setSeason] = useState(dateObj['selectboxSeason']);
    let todaySeason = (new Date()).getFullYear();
    let [loading, setLoading] = useState(false);

    useEffect(() => {
        let params = {
            seasons: season,
            authToken:JSON.stringify(cookies['hiball_token']),
            gameTypeCode: leagueType,
            groupingColumn: 'player'
        };

        if(type === 'batter') {
            params['recordType'] = 'battingRecord';
            params['recordName'] = 'selectBatterSimpleRecordGroupByTpa';
            params['batterId'] = playerId;
        } else {
            params['recordType'] = 'pitchingRecord';
            params['recordName'] = 'seasonPitcherSimpleRecordGroupByTpa';
            params['pitcherId'] = playerId;
        }

        let avgParam = {
            seasons: season,
            returnName: 'LeagueAvg',
            authToken:JSON.stringify(cookies['hiball_token']),
            gameTypeCode: leagueType
        }

        if(type === 'batter') {
            avgParam['recordType'] = 'battingRecord';
            avgParam['recordName'] = 'selectBatterSimpleRecordGroupByGameDay';
        } else {
            avgParam['recordType'] = 'pitchingRecord';
            avgParam['recordName'] = 'seasonPitcherSimpleRecordGroupByGameDay';
        }

        let tpaGroupPromise = axios({
            url: `${process.env.REACT_APP_API_URL}`,
            params 
        });

        let avgPromise = axios({
            url : `${process.env.REACT_APP_API_URL}`,
            params: avgParam
        });

        Promise.all([
            tpaGroupPromise, avgPromise
        ]).then((result) => {
            setLoading(true);
            let playerData = _.map(result[0]['data']['result'], (item) => {
                return {
                    gameDay: item['gameInfo']['gameDay'],
                    gameStime: item['gameInfo']['gameStime'],
                    stat: item['stat']
                }
            });
            
            setMovingChartData(playerData);

            let avgData = result[1]['data']['LeagueAvg'][0];
            setAvgStat(avgData);
        });
    }, [season]);

    function seasonHandler(event) {
        let value = event.target.value;
        setSeason(value);
    }

    if(!loading) {
        return <DefaultLoader />
    }

    return (
        <>
        <div style={{position:'absolute', top: '7px', left: '7px'}}>
            <Form.Group onChange={seasonHandler} style={{display:'inline-block', height: '29px'}}>
                <Form.Select size="sm" defaultValue={dateObj['selectboxSeason']}>
                    <option value={todaySeason-2}>{todaySeason-2}</option>
                    <option value={todaySeason-1}>{todaySeason-1}</option>
                    <option value={todaySeason}>{todaySeason}</option>
                </Form.Select>
            </Form.Group>
        </div>
        <div className="boxTitle"><img src={ballImage} style={{height:'25px'}} /> OPS</div>
        <div style={{display: 'flex', justifyContent: 'space-evenly'}}>
            <MovingChart data={movingChartData} count={50} avgData={avgStat} type={type}/>
            <MovingChart data={movingChartData} count={100} avgData={avgStat} type={type}/>
            <MovingChart data={movingChartData} count={250} avgData={avgStat} type={type}/>
        </div>
        </>
    )
}

export default MovingChartMain;